<template>
  <div>
    <h1>429 Too Many Request</h1>
  </div>
</template>

<script>
export default {
  mounted() {
  },
}
</script>
